import React, { useState } from 'react'
import { useLocation } from 'react-router-dom';
import { useCustomerDetailsTabMenuUtils } from '../../../../../../utils/tabNavigationUtils/provider/useCustomerDetailsTabMenuUtils';
import { routes } from '../../../../../../constants';
import { baseRouteMaker } from '../../../../../../constants/routeConsts';
import { Tabs } from '../../../../../common/tabs';

const CustomerInfoDetails = () => {
  
  /* location dependencies */
  const location = useLocation();
  /* location dependencies */

  const customerDetailsMenuGroup = useCustomerDetailsTabMenuUtils();

  const renderTabs = () => {
    const pathname = location.pathname;
    if (pathname.includes(baseRouteMaker(routes.SERVICE_PROVIDER_CUSTOMER_INFO_DETAILS))) {
      return customerDetailsMenuGroup;
    }
  };

  const listRoutesArray = new Array(
    ...customerDetailsMenuGroup
  )


  return (
    <>
    {
      listRoutesArray.some(
        (element) => element.url === location.pathname
      ) && <Tabs tabsMenuUtils={renderTabs()} />
    }
        
    </>
  )
}

export default CustomerInfoDetails